document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContadores();
  initComparadores();
  initGalerias();
  initVariantes();
  initUrgencia();
  initOferta();
});

function initOferta() {
  document.querySelectorAll('[data-mt-oferta]').forEach(function (bloque) {
    var opciones = bloque.querySelectorAll('[data-mt-oferta-opcion]');
    var form = bloque.closest('form');
    var qtyInput = form ? form.querySelector('[data-mt-oferta-qty]') : null;

    function actualizar() {
      opciones.forEach(function (op) {
        var radio = op.querySelector('[data-mt-oferta-radio]');
        var activa = radio.checked;
        op.classList.toggle('is-selected', activa);
        if (activa && qtyInput) qtyInput.value = radio.value;
      });
    }

    opciones.forEach(function (op) {
      op.addEventListener('click', function (e) {
        if (e.target.tagName === 'INPUT') return;
        var radio = op.querySelector('[data-mt-oferta-radio]');
        radio.checked = true;
        actualizar();
      });
      var radio = op.querySelector('[data-mt-oferta-radio]');
      radio.addEventListener('change', actualizar);
    });

    actualizar();
  });
}

function initUrgencia() {
  document.querySelectorAll('[data-mt-urgencia]').forEach(function (barra) {
    var horas = parseFloat(barra.getAttribute('data-horas')) || 5;
    var clave = barra.getAttribute('data-clave') || 'mt_oferta_fin';
    var duracionMs = horas * 60 * 60 * 1000;
    var fin;
    try {
      var guardado = window.localStorage.getItem(clave);
      fin = guardado ? parseInt(guardado, 10) : 0;
      if (!fin || fin <= Date.now()) {
        fin = Date.now() + duracionMs;
        window.localStorage.setItem(clave, String(fin));
      }
    } catch (e) {
      fin = Date.now() + duracionMs;
    }

    var elH = barra.querySelector('[data-mt-h]');
    var elM = barra.querySelector('[data-mt-m]');
    var elS = barra.querySelector('[data-mt-s]');
    if (!elH || !elM || !elS) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var restante = fin - Date.now();
      if (restante <= 0) {
        fin = Date.now() + duracionMs;
        try { window.localStorage.setItem(clave, String(fin)); } catch (e) {}
        restante = duracionMs;
      }
      var h = Math.floor(restante / 3600000);
      var m = Math.floor((restante % 3600000) / 60000);
      var s = Math.floor((restante % 60000) / 1000);
      elH.textContent = pad(h);
      elM.textContent = pad(m);
      elS.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  });
}

function initGalerias() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        principal.src = mini.getAttribute('data-imagen');
        principal.alt = mini.getAttribute('data-alt') || '';
        miniaturas.forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
      });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-mt-form-producto]').forEach(function (form) {
    var script = form.querySelector('[data-mt-variantes]');
    var selects = form.querySelectorAll('[data-mt-opcion]');
    if (!script || !selects.length) return;
    var variantes;
    try { variantes = JSON.parse(script.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-mt-variant-id]');
    var precioEl = form.closest('.mt-prod-compra') ? form.closest('.mt-prod-compra').querySelector('[data-mt-precio]') : null;
    var compararEl = form.closest('.mt-prod-compra') ? form.closest('.mt-prod-compra').querySelector('[data-mt-precio-comparar]') : null;
    var boton = form.querySelector('[data-mt-boton-comprar]');
    var botonTexto = form.querySelector('[data-mt-boton-texto]');

    function moneda(centavos) {
      if (window.Shopify && window.Shopify.formatMoney && window.theme_money_format) {
        return window.Shopify.formatMoney(centavos, window.theme_money_format);
      }
      return (centavos / 100).toFixed(2);
    }

    function actualizar() {
      var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
      var encontrada = variantes.find(function (v) {
        var opciones = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null && o !== undefined; });
        return opciones.every(function (o, i) { return o === seleccion[i]; });
      });
      if (!encontrada) return;
      if (idInput) idInput.value = encontrada.id;
      if (precioEl) precioEl.textContent = moneda(encontrada.price);
      if (compararEl) {
        if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
          compararEl.textContent = moneda(encontrada.compare_at_price);
          compararEl.style.display = '';
        } else {
          compararEl.style.display = 'none';
        }
      }
      if (boton) {
        boton.disabled = !encontrada.available;
        if (botonTexto) botonTexto.textContent = encontrada.available ? botonTexto.getAttribute('data-disponible') || botonTexto.textContent : botonTexto.getAttribute('data-agotado') || 'Agotado';
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { io.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('.mt-cifra[data-hasta]');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var hasta = parseFloat(el.getAttribute('data-hasta')) || 0;
        var prefijo = el.getAttribute('data-prefijo') || '';
        var sufijo = el.getAttribute('data-sufijo') || '';
        if (reduce) {
          el.textContent = prefijo + hasta + sufijo;
          return;
        }
        var inicio = null;
        var duracion = 1400;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var ease = 1 - Math.pow(1 - progreso, 3);
          var valor = Math.round(hasta * ease);
          el.textContent = prefijo + valor + sufijo;
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { io.observe(el); });
}

function initComparadores() {
  var wraps = document.querySelectorAll('.mt-comparador');
  wraps.forEach(function (wrap) {
    var despues = wrap.querySelector('.mt-comparador-despues');
    var asa = wrap.querySelector('.mt-comparador-asa');
    if (!despues || !asa) return;
    var arrastrando = false;

    function mover(clienteX) {
      var rect = wrap.getBoundingClientRect();
      var x = Math.min(Math.max(clienteX - rect.left, 0), rect.width);
      var pct = (x / rect.width) * 100;
      despues.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      asa.style.left = pct + '%';
    }

    wrap.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      wrap.setPointerCapture(e.pointerId);
      mover(e.clientX);
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      mover(e.clientX);
    });
    wrap.addEventListener('pointerup', function () { arrastrando = false; });
    wrap.addEventListener('pointercancel', function () { arrastrando = false; });
  });
}
